export enum E2EEErrors {
    E2EE_OLM_NO_ONE_TIME_KEYS = 'e2ee.olm.no-one-time-keys',
    E2EE_OLM_SESSION_ALREADY_EXISTS = 'e2ee.olm.session-already-exists',
    E2EE_OLM_SESSION_INIT_PENDING = 'e2ee.olm.session-init-pending',
    E2EE_SAS_CHANNEL_VERIFICATION_FAILED = 'e2ee.sas.channel-verification-failed',
    E2EE_SAS_COMMITMENT_MISMATCHED = 'e2ee.sas.commitment-mismatched',
    E2EE_SAS_INVALID_SAS_VERIFICATION = 'e2ee.sas.invalid-sas-verification',
    E2EE_SAS_KEYS_MAC_MISMATCH = 'e2ee.sas.keys-mac-mismatch',
    E2EE_SAS_MAC_MISMATCH = 'e2ee.sas.mac-mismatch',
    E2EE_SAS_MISSING_KEY =  'e2ee.sas.missing-key',
}
